const state = {
  title: '',
}
const mutations = {
  SET_TITLE: (state, title) => {
    state.title = title
    // document.title = `DomiDesk-在线客服系统 | ${title}`
    document.title = `哪吒练练 | ${title}`
  }
}

const actions = {
  // 设置网页标题
  setTitle({ commit }, data) {
    commit('SET_TITLE', data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

